// window.CONFIG is set in index.html by /config.js
// config.js is generated dynamically by webpack
export default window.CONFIG;
